import React from 'react'
import { useTranslation } from 'i18n'
import { DISPLAY_FORMATS } from './constants'
import Arrow from 'images/inline/listicle-step-arrow-right.svg'
import { OrderedListicleContents } from './OrderedListicleContents'

export const ListiclePanel = ({
  step,
  item,
  i,
  currentPosition,
  totalItems,
  backgroundImage,
  handlePrevClick,
  handleNextClick,
  voteButtonComponent,
  skipButton,
  nextStepButton,
}) => {
  const { t } = useTranslation(['listicle', 'common'])
  return (
    <>
      {item && (
        <div
          className={`db-react-slide `}
        >
          {step.listicle.displayFormat === DISPLAY_FORMATS.DEFAULT && (
            <div className="quiz__progress">
              <span className="progress-label">{t('listicle:label')}</span>
              <span className="quiz__progress-number">
                {t('common:counter', {
                  current: currentPosition,
                  total: totalItems,
                })}
              </span>
              <ul className="quiz__progress-dots">
                {Array.from({ length: totalItems }).map((_, i) => {
                  return (
                    <li
                      key={i}
                      className={`${i + 1 === currentPosition ? 'active' : ''}`}
                    ></li>
                  )
                })}
              </ul>
              <ul className="inner-arrows">
                <li>
                  <button
                    type="button"
                    className={`inner-prev`}
                    onClick={handlePrevClick}
                    aria-label={t('listicle:previous')}
                  ></button>
                </li>

                <li>
                  <button
                    type="button"
                    className={`inner-next`}
                    onClick={handleNextClick}
                    aria-label={t('common:next')}
                  ></button>
                </li>
              </ul>
            </div>
          )}
          {item.subhead && (
            <h2
              className="step-content__title"
              style={item.puckSubheadStyle}
              dangerouslySetInnerHTML={{
                __html: `${step.listicle.showNumbers ? i + 1 + '.' : ''} ${
                  item.subhead
                }`,
              }}
            />
          )}

          {(item.listicleContents || item.puckRows) && (
            <OrderedListicleContents
              step={step}
              item={item}
              voteButtonComponent={voteButtonComponent}
            />
          )}
          {step.listicle.displayFormat !== DISPLAY_FORMATS.default &&
            i === totalItems - 1 &&
            skipButton}
          {step.listicle.displayFormat === DISPLAY_FORMATS.default &&
            skipButton}
          {step.listicle.displayFormat === DISPLAY_FORMATS.default && (
            <div className="arrow">
              <Arrow onClick={handleNextClick} />
            </div>
          )}
        </div>
      )}
    </>
  )
}
